import styled from "styled-components";

export const FallbackFooterBackground = styled.footer`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 10vh;
  background: rgb(249, 249, 249);
  padding: 1rem;
`;

export const CopyrightMessage = styled.p`
  font-size: 0.75rem;
`;
